import React, { useEffect, useRef, useState } from "react"
import {
  Button,
  Cascader,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  message,
  Modal,
  notification,
  Popover,
  Radio,
  Row,
  Select,
  Space,
  Table,
} from "antd"
import axios from "axios"
import styles from "./reportCard.module.css"
import moment from "moment"
import { AXIOS_IP_REPORTCARD } from "./reportCardSlice"

export const ReportCardDetailModal = (props: {
  visible: boolean
  id: number
  type: boolean
  token: string
  onOk: () => void
  onCancel: () => void
}) => {

  const [form] = Form.useForm()

  const [confirmLoading, setConfirmLoading] = useState(false)

  const [detail, setDetail] = useState<any>()

  const submit = (type: number) => {
    Modal.confirm({
      title: '提示',
      content: `是否${type === 2 ? '无须上报' : '确认上报'}？`,
      okText: '确定',
      cancelText: '取消',
      onOk: () => {
        axios({
          url: `${AXIOS_IP_REPORTCARD}/emr/diseaseReport/review`,
          headers: {
            "Content-Type": "application/json",
            "His-Auth": props.token,
          },
          withCredentials: false,
          method: "POST",
          data: { 
            id: props?.id,
            reportStatus: type
          },
        }).then(() => {
          notification.success({
            message: '操作成功',
          })
          props.onOk()
        })
      },
    })
  }

  useEffect(() => {
    if (!props.visible) {
      form.resetFields()
    } else {
      if(props.id) {
        axios({
          url: `${AXIOS_IP_REPORTCARD}/emr/diseaseReport/detail`,
          headers: {
            "Content-Type": "application/json",
            "His-Auth": props.token,
          },
          withCredentials: false,
          method: "POST",
          data: { id: props.id },
        }).then((res) => { 
          const data = res.data.data
          setDetail({
            ...data,
            birthDate: data?.birthDate ? moment(data?.birthDate).format('YYYY-MM-DD') : '',
            onsetDate: data?.onsetDate ? moment(data?.onsetDate).format('YYYY-MM-DD') : '',
            diagnosisDate: data?.diagnosisDate ? moment(data?.diagnosisDate).format('YYYY-MM-DD HH时') : '',
            deathDate: data?.deathDate ? moment(data?.deathDate).format('YYYY-MM-DD') : '',
            reportTime: data?.reportTime ? moment(data?.reportTime).format('YYYY-MM-DD') : '',
          })
        })
      }
    }
  }, [props.visible, props.id])

  return (
    <>
      <Modal
        title={
          <div style={{ textAlign: "center" }}>中华人民共和国传染病报告卡</div>
        }
        width={1000}
        visible={props?.visible}
        onCancel={() => {
          props?.onCancel()
        }}
        onOk={form.submit}
        centered
        maskClosable={false}
        className={styles.selfModal}
        confirmLoading={confirmLoading}
        footer={null}
      >
        <div className={styles.selfRow}>
          <Row justify="space-between" className={styles.selfRow}>
            <Col>卡片编码：{ detail?.code }</Col>
            <Col>报卡类别：{ detail?.categoryName }</Col>
          </Row>
          <div 
            style={{ 
              border: '1px solid #EEEEEE', 
              borderRadius: '5px', 
              padding: '20px 8px 20px',
              height: 600,
              overflowY: "auto",
              overflowX: "hidden", 
            }}
          >
          <Row gutter={10} className={styles.selfRow}>
            <Col span={4} className={styles.selfCol}>
              姓名:
            </Col>
            <Col span={18}>
              <span>{ detail?.patientName }</span>
              <span style={{ paddingLeft: 10 }}>{ detail?.parentName ? `（患儿家长姓名：${detail?.parentName}）` : '' }</span>
            </Col>
          </Row>
          <Row className={styles.selfRow}>
            <Col span={12}>
              <Row gutter={10}>
                <Col span={8} className={styles.selfCol}>
                  有效证件号:
                </Col>
                <Col span={16}>
                  { detail?.idCard }
                </Col>
              </Row>
            </Col>
            <Col span={12}>
              <Row gutter={10}>
                <Col span={8} className={styles.selfCol}>
                  性别:
                </Col>
                <Col span={16}>
                  { detail?.sexName }
                </Col>
              </Row>
            </Col>
          </Row>
          <Row gutter={10} className={styles.selfRow}>
            <Col span={4} className={styles.selfCol}>
              出生日期:
            </Col>
            <Col span={18}>
              <span>{ detail?.birthDate || '-' }</span>
              <span style={{ paddingLeft: 10 }}>
                { `（如出生日期不详，实足年龄：${detail?.chronologicalAge || '-'} 岁 ，
                年龄单位：${detail?.ageYear || '-'}岁 ${detail?.ageMonth || '-'} 月 ${detail?.ageDay || '-'} 天 ）`}
              </span>
            </Col>
          </Row>
          <Row className={styles.selfRow}>
            <Col span={12}>
              <Row gutter={10}>
                <Col span={8} className={styles.selfCol}>
                  工作单位（学校）:
                </Col>
                <Col span={16}>
                  { detail?.workunit || '-' }
                </Col>
              </Row>
            </Col>
            <Col span={12}>
              <Row gutter={10}>
                <Col span={8} className={styles.selfCol}>
                  联系电话:
                </Col>
                <Col span={16}>
                  { detail?.tel || '-' }
                </Col>
              </Row>
            </Col>
          </Row>
          <Row gutter={10} className={styles.selfRow}>
            <Col span={4} className={styles.selfCol}>
              病人属于:
            </Col>
            <Col span={18}>{ detail?.jurisdictionCategoryName }</Col>
          </Row>
          <Row gutter={10} className={styles.selfRow}>
            <Col span={4} className={styles.selfCol}>
              现住址（详填）:
            </Col>
            <Col span={18}>{ detail?.currentAddrName }{ detail?.currentAddrDetail }</Col>
          </Row>
          <Row gutter={10} className={styles.selfRow}>
            <Col span={4} className={styles.selfCol}>
              人群分类:
            </Col>
            <Col span={18}>
              <span>{ detail?.nultitudeTypeName }</span>
              <span style={{ paddingLeft: 10 }}>{ detail?.nultitudeType == 16 ? detail?.nultitudeTypeOther : '' }</span>
            </Col>
          </Row>
          <Row gutter={10} className={styles.selfRow}>
            <Col span={4} className={styles.selfCol}>
              病历分类:
            </Col>
            <Col span={18}>
              <div>（1）{ detail?.firstCaseClassificationName }</div>
              {detail?.secondCaseClassificationName && <div>（2）{ detail?.secondCaseClassificationName }</div>}
            </Col>
          </Row>
          <Row gutter={10} className={styles.selfRow}>
            <Col span={4} className={styles.selfCol}>
              发病日期:
            </Col>
            <Col span={18}>{ detail?.onsetDate }</Col>
          </Row>
          <Row gutter={10} className={styles.selfRow}>
            <Col span={4} className={styles.selfCol}>
              诊断日期:
            </Col>
            <Col span={18}>{ detail?.diagnosisDate }</Col>
          </Row>
          <Row gutter={10} className={styles.selfRow}>
            <Col span={4} className={styles.selfCol}>
              死亡日期:
            </Col>
            <Col span={18}>{ detail?.deathDate || '-' }</Col>
          </Row>
          <Divider style={{ color: '#EEEEEE', marginTop: 0,  }} />
          <Row gutter={10} className={styles.selfRow}>
            <Col span={4} className={styles.selfCol}>
              甲类传染病:
            </Col>
            <Col span={18}>{ detail?.infectiousDiseaseAName || '-' }</Col>
          </Row>
          <Row gutter={10} className={styles.selfRow}>
            <Col span={4} className={styles.selfCol}>
              乙类传染病:
            </Col>
            <Col span={18}>{ detail?.infectiousDiseaseBName || '-' }</Col>
          </Row>
          <Row gutter={10} className={styles.selfRow}>
            <Col span={4} className={styles.selfCol}>
              丙类传染病:
            </Col>
            <Col span={18}>{ detail?.infectiousDiseaseCName || '-' }</Col>
          </Row>
          <Row gutter={10} className={styles.selfRow}>
            <Col span={4} className={styles.selfCol}>
              其他法定管理以及重点监测传染病:
            </Col>
            <Col span={18}>{ detail?.infectiousDiseaseOther || '-' }</Col>
          </Row>
          <Divider style={{ color: '#EEEEEE', marginTop: 0, marginBottom: 12 }} />
          <Row>
            <Col span={12} className={styles.selfRow}>
              <Row gutter={10}>
                <Col span={8} className={styles.selfCol}>
                  订正病名:
                </Col>
                <Col span={16}>
                  { detail?.correctedDiseaseName || '-' }
                </Col>
              </Row>
            </Col>
            <Col span={12} className={styles.selfRow}>
              <Row gutter={10}>
                <Col span={8} className={styles.selfCol}>
                  退卡原因:
                </Col>
                <Col span={16}>
                  { detail?.rejectionReason || '-' }
                </Col>
              </Row>
            </Col>
            <Col span={12} className={styles.selfRow}>
              <Row gutter={10}>
                <Col span={8} className={styles.selfCol}>
                  报告单位:
                </Col>
                <Col span={16}>
                  { detail?.reportUnit || '-' }
                </Col>
              </Row>
            </Col>
            <Col span={12}>
              <Row gutter={10}>
                <Col span={8} className={styles.selfCol}>
                  联系电话:
                </Col>
                <Col span={16}>
                  { detail?.reportTel || '-' }
                </Col>
              </Row>
            </Col>
            <Col span={12}>
              <Row gutter={10}>
                <Col span={8} className={styles.selfCol}>
                  填卡医生:
                </Col>
                <Col span={16}>
                  { detail?.reportDoctor || '-' }
                </Col>
              </Row>
            </Col>
            <Col span={12} className={styles.selfRow}>
              <Row gutter={10}>
                <Col span={8} className={styles.selfCol}>
                  填卡日期:
                </Col>
                <Col span={16}>
                  { detail?.reportTime || '-' }
                </Col>
              </Row>
            </Col>
          </Row>
          <Divider style={{ color: '#EEEEEE', marginTop: 0,  }} />
          <Row gutter={10} className={styles.selfRow}>
            <Col span={4} className={styles.selfCol}>
              备注:
            </Col>
            <Col span={18}>{ detail?.memo || '-' }</Col>
          </Row>
          </div>
        </div>
        {props.type && <Row justify="center" style={{ marginTop: 20 }}>
          <Space>
            <Button
              size="large"
              style={{ color: '#07C160', borderColor: '#07C160' }}
              onClick={() => submit(2)}
            >
              无须上报
            </Button>
            <Button
              type="primary"
              size="large"
              onClick={() => submit(3)}
            >
              确认上报
            </Button>
          </Space>
        </Row>}
      </Modal>

    </>
  )
}
